





















































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import DateTimeMixin from "@/components/mixin/date-time-mixin";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import _ from "lodash";
import PrintCollectionCodesInSession from "./print-collectionCodeInSession.vue";
class PageCollectionCodeTrackingRequest extends PageRequest {
  id: number;
}
@Component({
  components: {
    "print-collection-code-in-session": PrintCollectionCodesInSession,
  },
})
export default class ViewSessionPrintCollectionCode extends mixins(
  ListMixin,
  DateTimeMixin,
  AbpBase
) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  namespace = "collectionCode";
  sessionPrintcollectionCode: any = null;
  pagerequest: PageCollectionCodeTrackingRequest = new PageCollectionCodeTrackingRequest();
  spinShow: boolean = false;
  id: number = 0;
  printModalShow: boolean = false;
  selectedCodes = [];
  get store() {
    return this.$store.state.collectionCode;
  }
  cancel() {
    (this.$refs.viewSessionPrintCollectionCodeForm as any).resetFields();
    this.$emit("input", false);
    this.$root.$router.push({ name: "sessionPrint" });
  }
  get list() {
    var re = this.$store.state.collectionCode.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  async getSelectedCodes() {
    await this.$store
      .dispatch({
        type: `${this.namespace}/getProductCodesBySessionId`,
        data: { id: this.id },
      })
      .then((res) => {
        console.log("res", res);
        this.selectedCodes = res;
      });
  }
  preGetPage() {
    this.pagerequest.id = this.id;
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    this.preGetPage();
    await this.$store
      .dispatch({
        type: `${this.namespace}/getCollectionCodeBySessionId`,
        data: this.pagerequest,
      })
      .catch(() => {
        this.store.loading = false;
      });
  }

  async exportCollectionCode() {
    await this.$store.dispatch({
      type: `collectionCode/exportCollectionCodesBySessionId`,
      data: {
        id: this.id,
      },
    });
  }

  printCollectionCode() {
    this.getSelectedCodes();
    this.printModalShow = true;
  }

  onCancelPopupPrinter() {
    this.printModalShow = false;
  }

  onDownloadFilePrinter() {
    this.printModalShow = false;
  }

  async created() {
    this.spinShow = true;
    try {
      this.id = +this.$root.$router.currentRoute.params.id;
      this.$store
        .dispatch({
          type: `sessionPrintCollectionCode/get`,
          data: { id: this.id },
        })
        .then((result) => {
          this.sessionPrintcollectionCode = result;
          this.searchData();
        });
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }

  get columns() {
    return [
      {
        title: Util.L("Order"),
        width: 50,
        key: "orderNo",
      },
      {
        title: Util.L("HiddenCode"),
        key: "hiddenCode",
      },
      {
        title: Util.L("MainSerialNo"),
        key: "mainSerialNo",
      },
      {
        title: Util.L("SubSerialNo"),
        key: "subSerialNo",
      },
    ];
  }
}
